import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';

import {useSearchMgrInstance} from 'coreHooks';

import AccordionGroup, {AccordionGroupItem} from 'brandComponents/core/AccordionGroup';

import {useRefinementsContext} from '../FlyoutFilterContext';
import {getRefinementComponent} from '../helpers';

import FiltersRefinementContent from './SubComponents/FiltersRefinementContent';
import FiltersRefinementIndicator from './SubComponents/FiltersRefinementIndicator';
import messages from './messages';

import styles from './FiltersRefinement.module.scss';

const FiltersRefinement = () => {
	const intl = useIntl();
	const {searchConfig} = useRefinementsContext();
	const searchMgr = useSearchMgrInstance({
		key: searchConfig.searchInstanceKey,
		searchType: searchConfig.searchType,
	});
	const searchModel = searchMgr?.getStoredSearchModel();
	const sortingOptions = searchModel.getSortingOptions();
	const selectedSortingOption = searchModel?.getSelectedSortingOption();
	const selectedOptionLabel = useMemo(() => {
		const fallbackLabel = sortingOptions.find(
			(sortingOption) => sortingOption.id === selectedSortingOption
		)?.label;

		const label =
			messages[selectedSortingOption]
				? intl.formatMessage(messages[selectedSortingOption]) || fallbackLabel
				: fallbackLabel;

		return label?.toLowerCase();
	}, [selectedSortingOption]);

	const refinements = searchModel?.getRefinements();

	if (!refinements) {
		return null;
	}

	return (
		<div className={styles['filters-refinement__container']}>
			<AccordionGroup>
				<AccordionGroupItem
					key="sorting-refinement"
					title={
						<span className="filters-refinement__indicator">
							<span>{intl.formatMessage(messages.sortBy)}</span>
							<span className="filters-refinement__sort">{selectedOptionLabel}</span>
						</span>
					}
					classNames="accordion_group-item"
					content={
						<FiltersRefinementContent>
							<FiltersRefinementContent.Sorting />
						</FiltersRefinementContent>
					}
				/>
				{
					refinements?.map((refinement) => {
						const attributeId = refinement.getAttributeId();
						const Component = getRefinementComponent(attributeId);

						return (
							<AccordionGroupItem
								key={refinement.getAttributeId()}
								title={<FiltersRefinementIndicator refinement={refinement}/>}
								classNames="accordion_group-item"
								content={
									<FiltersRefinementContent>
										<Component refinement={refinement}/>
									</FiltersRefinementContent>
								}
							/>
						);
					})
				}
			</AccordionGroup>
		</div>
	);
};

export default FiltersRefinement;
